import EfLink from '@elem/ui/ef-link';
import { message } from 'antd-v5';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFMail, EFPhone, EFAIChat } from '@/components/UI/svg/Support';

export default function SupportContactUs({ isShow = false, nodata = false }: any) {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();

    const emailMap = {
        fr: 'mailto:support.eu@ecoflow.com',
        de: 'mailto:support.eu@ecoflow.com',
        es: 'mailto:support.eu@ecoflow.com',
        it: 'mailto:support.eu@ecoflow.com',
        nl: 'mailto:support.eu@ecoflow.com',
        us: 'mailto:support@ecoflow.com',
        uk: 'mailto:support.eu@ecoflow.com',
        au: 'mailto:support.au@ecoflow.com',
        jp: 'mailto:support.jp@ecoflow.com',
        eu: 'mailto:support.eu@ecoflow.com',
        sa: 'mailto:support.me@ecoflow.com',
    } as any;

    const telMap = {
        us: 'tel:+1(800)-368-8604',
        jp: 'tel:+81(050)-3090-2966',
        cn: 'tel:400-600-5753',
        za: 'tel:+27(080)-088-0002',
    } as any;

    const showTel = ['cn'];
    const onClick = (type: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'get_support',
            button_name: type,
        });
    };

    const onQuiry = () => {
        if (locale === 'jp') {
            window.open('https://jp.ecoflow.com/pages/contactus', '_blank');
        }
    };

    const handleOpenChat = () => {
        try {
            (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
        } catch (error) {}
    };

    const handleCopy = async (val: string) => {
        try {
            await navigator.clipboard.writeText(val);
            message.open({
                type: 'success',
                content: 'クリップボードに正常にコピーされました！',
                style: {
                    position: 'relative',
                    top: 80,
                },
            });
        } catch (error) {
            message.open({
                type: 'error',
                content: 'クリップボードにコピーできませんでした！',
                style: {
                    position: 'relative',
                    top: 80,
                },
            });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'get_support',
            button_name: '050-3090-2966',
        });
    };

    return (
        <>
            {isShow ? (
                <div className={`${css.supportContact} supportContact ${nodata ? 'nodata' : ''}`}>
                    <div>
                        <h2 className="font-family-semibold supportContactTitle" onClick={onQuiry}>
                            {t('support.site_support_contact_us')}
                        </h2>
                        <div className="contact-list">
                            <ul>
                                {locale !== 'cn' && (
                                    <li>
                                        <a
                                            href={emailMap[locale] || emailMap.us}
                                            aria-label={t('support.site_support_email_us')}
                                            onClick={() => onClick('Email Us')}
                                        >
                                            <EFMail />
                                            <p className="font-family-medium">{t('support.site_support_email_us')}</p>
                                        </a>
                                    </li>
                                )}
                                {telMap[locale] && (
                                    <li>
                                        <a href={telMap[locale]} aria-label={t('support.site_support_call_us')} onClick={() => onClick('Call Us')}>
                                            <EFPhone />
                                            <p className="font-family-medium">{t('support.site_support_call_us')}</p>
                                        </a>
                                        {showTel?.includes(locale) && <p className="telNum">{telMap[locale].split(':')[1]}</p>}
                                        {/* {locale === 'jp' && <p className="telNum">{t('support.site_support_tel_note')}</p>} */}
                                        {locale === 'jp' && (
                                            <>
                                                <EfLink
                                                    className="item-link support-link link-mobile"
                                                    href={`tel:050-3090-2966`}
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'get_support',
                                                        button_name: '050-3090-2966',
                                                    }}
                                                >
                                                    050-3090-2966
                                                </EfLink>
                                                <a className="item-link support-link link-pc" onClick={() => handleCopy('050-3090-2966')}>
                                                    050-3090-2966
                                                </a>
                                                <div className="item-desc">10:00~19:00（土日祝日を除く）</div>
                                            </>
                                        )}
                                    </li>
                                )}
                                {locale === 'jp' && (
                                    <li className="jp-ai-chat" onClick={handleOpenChat}>
                                        <EFAIChat />
                                        <p className="font-family-medium">{'インテリジェントチャット'}</p>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ minHeight: '150px' }}></div>
            )}
        </>
    );
}
